import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

import { initHeroAnimation } from "./hero-animation.js"
import { initScrollAnimations } from "./scroll-animations.js"

// Shrinking header on scroll
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('header')
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 10) {
        header.classList.add('scrolled')
      } else {
        header.classList.remove('scrolled')
      }
    }, { passive: true })
  }

  initHeroAnimation()
  initScrollAnimations()
})
